/* progressive enhancement: the store works without JavaScript */
(() => {
  document.documentElement.classList.remove('no-js');
  const $ = (selector, root=document) => root.querySelector(selector);
  const $$ = (selector, root=document) => [...root.querySelectorAll(selector)];
  const toast = (message) => { const el = $('#nd-toast'); if (!el) return; el.textContent = message; el.hidden = false; clearTimeout(window.ndToastTimer); window.ndToastTimer=setTimeout(() => {el.hidden=true}, 4200); };
  $$('[data-nd-mobile-toggle]').forEach(toggle => toggle.addEventListener('click', () => {
    const menu = $('#nd-mobile-menu'); if (!menu) return;
    const expand = menu.hidden; menu.hidden = !expand; toggle.setAttribute('aria-expanded', String(expand));
  }));
  $$('[data-nd-qty]').forEach(widget => {
    const input=$('input',widget); if(!input) return;
    $$('[data-nd-adjust]',widget).forEach(button => button.addEventListener('click', () => {
      const next=Number(input.value||1)+Number(button.dataset.ndAdjust); input.value=String(Math.max(Number(input.min||0),Math.min(Number(input.max||999),next)));input.dispatchEvent(new Event('change',{bubbles:true}));
    }));
  });
  $$('[data-nd-thumb]').forEach(button => button.addEventListener('click', () => {
    const img=$('[data-nd-main-image]'); if(!img) return;
    img.src=button.dataset.ndThumb; img.alt=button.dataset.ndAlt||img.alt;
    $$('[data-nd-thumb]').forEach(b=>b.setAttribute('aria-current',String(b===button)));
  }));
  $$('[data-nd-sort]').forEach(select => select.addEventListener('change',() => {
    const params = new URLSearchParams(window.location.search); if(select.value)params.set('sort_by',select.value);else params.delete('sort_by');params.delete('page');window.location.search=params.toString();
  }));
  $$('[data-nd-price-form]').forEach(form => form.addEventListener('submit', event => {
    event.preventDefault(); const params=new URLSearchParams(window.location.search);
    [...new FormData(form).entries()].forEach(([key,value])=>{ if(String(value).trim())params.set(key,value);else params.delete(key); });
    params.delete('page'); window.location.search=params.toString();
  }));
  $$('[data-nd-variant-selector]').forEach(select => select.addEventListener('change',() => {
    const option = select.options[select.selectedIndex]; const info=$('[data-nd-price]');
    if(info && option.dataset.price) info.textContent=option.dataset.price;
    const button=$('[data-nd-add-btn]'); if(button){button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?'Sold out':'Add to cart';}
    const params=new URLSearchParams(window.location.search);params.set('variant',select.value);history.replaceState(null,'',`${window.location.pathname}?${params.toString()}`);
  }));
  $$('[data-nd-ajax-add]').forEach(form => form.addEventListener('submit', async event => {
    if (!window.fetch || !window.FormData) return;
    event.preventDefault(); const button=$('button[type=submit]',form);if(button)button.disabled=true;
    try {
      const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
      const result=await response.json();if(!response.ok)throw Error(result.description||'Unable to add this product');
      const cart=await fetch((window.Shopify?.routes?.root||'/')+'cart.js').then(r=>r.json());
      $$('[data-nd-cart-count]').forEach(el=>el.textContent=cart.item_count);
      toast('Added to your drawer ✓');
    } catch(error){ toast(error.message||'Unable to add product. Please try again.'); }
    finally{if(button)button.disabled=false;}
  }));
  const escapeHtml = (text) => String(text||'').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  $$('[data-nd-predictive]').forEach(form => {
    const input=$('input[name=q]',form);const results=$('[data-nd-results]',form);
    if(!input||!results||form.dataset.enabled!=='true')return;
    let controller; let requestId=0;
    input.addEventListener('input', async () => {
      const term=input.value.trim();requestId++;const thisRequest=requestId;
      if(controller)controller.abort();results.innerHTML='';if(term.length<2)return;
      controller=new AbortController();
      try {
        const root=window.Shopify?.routes?.root||'/';
        const url=`${root}search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=5`;
        const response=await fetch(url,{signal:controller.signal});if(!response.ok)return;
        const json=await response.json();if(thisRequest!==requestId)return;
        const products=json.resources?.results?.products||[];
        products.forEach(product => {
          const a=document.createElement('a');a.href=product.url;
          if(product.featured_image?.url){const im=document.createElement('img'); im.loading='lazy'; im.src=product.featured_image.url; im.alt='';a.appendChild(im);}
          const span=document.createElement('span');span.textContent=product.title;a.appendChild(span);results.appendChild(a);
        });
        if(products.length){const more=document.createElement('a');more.href=`${root}search?q=${encodeURIComponent(term)}&type=product`;more.textContent='View all search results →';results.appendChild(more);}
      }catch(error){if(error.name!=='AbortError')results.innerHTML='';}
    });
    document.addEventListener('click',e=>{if(!form.contains(e.target))results.innerHTML='';});
  });
})();

// Neon V8 product carousel controls: fully keyboard and pointer accessible.
(() => {
  document.querySelectorAll('[data-v8-carousel]').forEach(section => {
    const tabs = [...section.querySelectorAll('[data-v8-tab]')];
    const panels = [...section.querySelectorAll('[data-v8-panel]')];
    const show = target => {
      tabs.forEach(tab => {
        const selected = tab.dataset.v8Tab === target;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      panels.forEach(panel => { panel.hidden = panel.dataset.v8Panel !== target; });
    };
    tabs.forEach((tab,index) => {
      tab.addEventListener('click', () => show(tab.dataset.v8Tab));
      tab.addEventListener('keydown', e => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        const direction = e.key === 'ArrowRight' ? 1 : -1;
        const next = tabs[(index + direction + tabs.length) % tabs.length];
        show(next.dataset.v8Tab); next.focus();
      });
    });
    const currentTrack = () => section.querySelector('[data-v8-panel]:not([hidden]) [data-v8-scroll]');
    section.querySelectorAll('[data-v8-prev],[data-v8-next]').forEach(button => {
      button.addEventListener('click', () => {
        const track = currentTrack(); if(!track) return;
        const card = track.querySelector('.nd-product');
        const gap = parseFloat(getComputedStyle(track).columnGap) || 12;
        const distance = card ? card.getBoundingClientRect().width + gap : 240;
        track.scrollBy({left:distance*(button.hasAttribute('data-v8-next') ? 2 : -2),behavior:'smooth'});
      });
    });
  });
})();


/* Neon V8.3 accessible pause/resume. Theme editor section reload compatible. */
(() => {
  const setup = root => {
    const nodes = [];
    if (root.matches?.('[data-nd-v83-marquee]')) nodes.push(root);
    root.querySelectorAll?.('[data-nd-v83-marquee]').forEach(node => nodes.push(node));
    nodes.forEach(section => {
      if (section.dataset.ndV83Ready) return;
      section.dataset.ndV83Ready='1';
      const btn = section.querySelector('[data-nd-marquee-pause]');
      btn?.addEventListener('click', () => {
        const paused = section.classList.toggle('is-paused');
        btn.setAttribute('aria-pressed',String(paused));
        btn.textContent = paused ? 'Resume movement ▶' : 'Pause movement ⏸';
      });
    });
  };
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();


/* V8.7 review carousel. Shopify Theme Editor reload-aware; only genuine review data is displayed. */
(()=>{
 const esc = v => String(v==null?'':v).trim();
 function setup(section){
  if(!section || section.dataset.ndV87Ready==='1')return;
  section.dataset.ndV87Ready='1';
  const track=section.querySelector('[data-nd-v87-track]');
  const nav=section.querySelector('[data-nd-v87-nav]');
  const empty=section.querySelector('[data-nd-v87-empty]');
  const dots=section.querySelector('[data-nd-v87-dots]');
  const appBlocks=section.querySelectorAll('.nd-v87-reviews__app');
  let timer;
  // Trustify's shop metafield holds published review records, not fabricated seed data.
  try{
   const raw=section.querySelector('[data-nd-v87-data]')?.textContent||'{}';
   let state=JSON.parse(raw);
   if(typeof state==='string')state=JSON.parse(state);
   const reviews=Array.isArray(state?.reviews)?state.reviews:[];
   reviews.forEach(review=>{
    const quote=esc(review.content||review.review_content||review.body||review.comment||review.text);
    if(!quote)return;
    const rating=Number(review.rating??review.stars??review.rating_value);
    const name=esc(review.reviewer_name||review.customer_name||review.author_name||review.name||review.user_name||review.reviewer?.name||'Customer');
    const card=document.createElement('article');card.className='nd-v87-review';
    if(Number.isFinite(rating)&&rating>=1&&rating<=5){
      const star=document.createElement('div');star.className='nd-v87-review__rating';
      star.textContent='★'.repeat(Math.round(rating))+'☆'.repeat(5-Math.round(rating));
      star.setAttribute('aria-label',rating+' out of 5 stars');card.appendChild(star);
    }
    const body=document.createElement('blockquote');body.className='nd-v87-review__quote';body.textContent=quote;card.appendChild(body);
    const footer=document.createElement('div');footer.className='nd-v87-review__footer';
    const author=document.createElement('span');author.className='nd-v87-review__author';author.textContent=name;footer.appendChild(author);
    card.appendChild(footer);track.appendChild(card);
   });
  }catch(_error){/* No parseable reviews means no testimonials, not invented content. */}
  const cards=[...track.querySelectorAll('.nd-v87-review')];
  if(!cards.length){track.hidden=true;nav.hidden=true;dots.hidden=true;empty.hidden=appBlocks.length>0;return;}
  empty.hidden=true;track.hidden=false;
  const getCardStep=()=>{
    const card=track.querySelector('.nd-v87-review');
    return card?card.getBoundingClientRect().width+(parseFloat(getComputedStyle(track).gap)||13):track.clientWidth;
  };
  const maxScroll=()=>Math.max(0,track.scrollWidth-track.clientWidth);
  function slide(dir){
    const step=getCardStep();
    if(maxScroll()<10)return;
    const target=track.scrollLeft+dir*step;
    const left=dir>0&&target>maxScroll()+step/2?0:dir<0&&target<-step/2?maxScroll():Math.max(0,Math.min(maxScroll(),target));
    track.scrollTo({left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  }
  const prev=section.querySelector('[data-nd-v87-prev]');
  const next=section.querySelector('[data-nd-v87-next]');
  prev?.addEventListener('click',()=>{stop();slide(-1);restart();});
  next?.addEventListener('click',()=>{stop();slide(1);restart();});
  const countPages=()=>Math.max(1,Math.ceil(maxScroll()/getCardStep())+1);
  function update(){
    const active=maxScroll()>=10;
    nav.hidden=!active;
    dots.hidden=!active;
    dots.replaceChildren();
    if(!active){stop();return;}
    const count=Math.min(cards.length,countPages());
    const current=Math.min(count-1,Math.round(track.scrollLeft/getCardStep()));
    for(let i=0;i<count;i++){
      const dot=document.createElement('button');dot.type='button';dot.className='nd-v87-reviews__dot'+(i===current?' is-active':'');
      dot.setAttribute('aria-label','Go to review '+(i+1));
      dot.addEventListener('click',()=>{stop();track.scrollTo({left:Math.min(maxScroll(),i*getCardStep()),behavior:'smooth'});restart()});
      dots.appendChild(dot);
    }
  }
  let ticking=false;
  track.addEventListener('scroll',()=>{if(ticking)return;ticking=true;requestAnimationFrame(()=>{ticking=false;update()})},{passive:true});
  const delay=Math.max(4000,Math.min(12000,Number(section.dataset.ndV87Delay)||6000));
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  function stop(){if(timer){clearInterval(timer);timer=null}}
  function restart(){if(section.dataset.ndV87Autoplay==='false'||reduced.matches||maxScroll()<10||document.hidden)return;
    stop();timer=setInterval(()=>slide(1),delay);
  }
  section.addEventListener('mouseenter',stop);
  section.addEventListener('mouseleave',restart);
  section.addEventListener('focusin',stop);
  section.addEventListener('focusout',event=>{if(!section.contains(event.relatedTarget))restart()});
  document.addEventListener('visibilitychange',()=>document.hidden?stop():restart());
  window.addEventListener('resize',()=>{update();restart()},{passive:true});
  section.addEventListener('nd:v87:destroy',stop,{once:true});
  update();restart();
 }
 const init=root=>{
   if(root.matches?.('[data-nd-v87-reviews]'))setup(root);
   root.querySelectorAll?.('[data-nd-v87-reviews]').forEach(setup);
 };
 const run=()=>init(document);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});else run();
 document.addEventListener('shopify:section:load',event=>init(event.target));
 document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-nd-v87-reviews]').forEach(x=>x.dispatchEvent(new CustomEvent('nd:v87:destroy'))));
})();


/* V8.18: mobile/desktop expanded search in the approved V8.17 header. */
(()=>{document.querySelectorAll('[data-v817-search-toggle]').forEach(btn=>btn.addEventListener('click',()=>{const form=document.getElementById('nd-v817-search');if(!form)return;const open=form.hidden;form.hidden=!open;btn.setAttribute('aria-expanded',String(open));if(open)form.querySelector('input[name="q"]')?.focus();}));})();
